import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import Players from '@/views/team/tabs/Players.vue';

export const teamPlayersRoute = {
  path: '',
  name: 'teamPlayers',
  component: Players,
  meta: { title: 'titles.team.players' },
  beforeEnter: (to: any, from: any, next: any) =>
    store
      .dispatch('team/player/list', { teamId: tryParseInt(to.params.teamId) })
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: 'messages.team.player.listError' }))
};
